import { useEffect, useState } from "react";

function diferencaTempo(alvoIso) {
  const alvo = new Date(alvoIso).getTime();
  const agora = Date.now();
  const diff = alvo - agora;
  if (diff <= 0) return { encerrado: true, label: "ENCERRADO" };
  const dias = Math.floor(diff / (1000 * 60 * 60 * 24));
  const horas = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutos = Math.floor((diff / (1000 * 60)) % 60);
  const segundos = Math.floor((diff / 1000) % 60);
  if (dias > 0) return { encerrado: false, label: `${dias}D ${horas}H ${minutos}M` };
  if (horas > 0) return { encerrado: false, label: `${horas}H ${minutos}M ${segundos}S` };
  return { encerrado: false, label: `${minutos}M ${segundos}S` };
}

export function ContagemRegressiva({ alvoIso, testId }) {
  const [estado, setEstado] = useState(() => diferencaTempo(alvoIso));

  useEffect(() => {
    const t = setInterval(() => setEstado(diferencaTempo(alvoIso)), 1000);
    return () => clearInterval(t);
  }, [alvoIso]);

  if (estado.encerrado) {
    return (
      <span
        data-testid={testId}
        className="inline-flex items-center px-3 py-1 rounded-full bg-red-500/15 text-red-400 font-mono font-bold text-xs tracking-widest"
      >
        ENCERRADO
      </span>
    );
  }

  return (
    <span
      data-testid={testId}
      className="inline-flex items-center px-3 py-1 rounded-full bg-amarelobrasil-soft text-amarelobrasil font-mono font-bold text-xs tracking-widest animate-pulse-yellow"
    >
      {estado.label}
    </span>
  );
}
